import { Component, Input } from '@angular/core';

@Component({
  selector: 'sg-background-icon',
  templateUrl: './background-icon.component.html',
  styleUrls: ['./background-icon.component.scss'],
  standalone: false,
})
export class SgBackgroundIconComponent {
  @Input() size: string;

  backgroundIconStyle() {
    return {
      height: this.size,
      width: this.size,
      'font-size': this.size,
    };
  }

  constructor() {}
}
